module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.$store.state.is_manager) ? _c('div', [_c('div', {
    staticClass: "select-container clearfix",
    staticStyle: {
      "margin-top": "6%",
      "margin-left": "33%",
      "float": "center"
    }
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "label-width": "80px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "删除文档"
    }
  }, [_c('el-cascader', {
    ref: "cascader",
    attrs: {
      "change-on-select": "",
      "options": _vm.form.options,
      "clearable": ""
    },
    model: {
      value: (_vm.selectedItemList),
      callback: function($$v) {
        _vm.selectedItemList = $$v
      },
      expression: "selectedItemList"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.open
    }
  }, [_vm._v("删除")])], 1)], 1)], 1)]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-eae95e7a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/deleteItem.vue
// module id = 658
// module chunks = 1